import { Select } from "@amzn/uxm-aws-ui-components-react/lib/src/polaris/select";
import FormFieldWrapper from "./FormFieldWrapper/FormFieldWrapper";
import { CustomSelectFormFieldProps } from "interfaces";

/**
 * A FormField that provides a select input
 *
 * @param {string} label - The form field label
 * @param {string} value - The current input value
 * @param {function} setValue - Function to update the current input value
 * @param {string} errorText - Error message to display
 * @param {string} warningText - Warning message to display
 * @param {string} description - Description text for the field
 * @param {React.ReactNode} info - Additional info to display
 * @param {string} placeholder - Placeholder text for the date input
 * @param {boolean} disabled - Whether the input is disabled
 * @param {string} [testId] - Test identifier for the component
 *
 * @returns {JSX.Element} A FormField component with a Select
 */
const CustomSelectFormField = ({
    label,
    errorText,
    warningText,
    description,
    info,
    value,
    setValue,
    options,
    placeholder,
    disabled,
    testId,
    touchpoint,
}: CustomSelectFormFieldProps) => {
    return (
        <FormFieldWrapper
            testId={testId}
            label={label}
            errorText={errorText}
            warningText={warningText}
            description={description}
            info={info}
            input={
                <Select
                    selectedOption={value}
                    onChange={({ detail }) => setValue(detail.selectedOption)}
                    placeholder={placeholder}
                    disabled={disabled}
                    options={options}
                    filteringType="auto"
                    touchpoint={touchpoint}
                />
            }
        />
    );
};

export default CustomSelectFormField;
